/**
 * Focus this element when the page loads.
 */
export const autoFocus = {
    /**
     * @param {HTMLInputElement} el
     */
    mounted(el) {
        setTimeout(() => {
            el.focus();
        }, 100);
    },
};
